// Shared back-navigation button. Replaces the 13+ inline `← Back` text
// links scattered through the routes — gives all of them a consistent
// 44px tap target + lucide chevron + standard label.

import { ChevronLeft } from "lucide-react";

interface Props {
  onClick: () => void;
  /** Label after the chevron — defaults to "Back". */
  label?: string;
  className?: string;
}

export default function BackButton({ onClick, label = "Back", className = "" }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`inline-flex items-center gap-1 text-sm text-slate-400 hover:text-slate-200 min-h-[44px] -ml-1.5 px-1.5 rounded-md ${className}`}
      aria-label={label}
    >
      <ChevronLeft className="w-4 h-4" strokeWidth={2} />
      {label}
    </button>
  );
}
